<img
  [src]="'https://flagcdn.com/' + isoCode?.toLowerCase() + '.svg'"
  width="20"
  height="20"
  [alt]="isoCode + 'icon'"
  class="rounded-full h-4 w-4 object-cover"
  lazyLoad
  *ngIf="isoCode" />
